module.exports = __webpack_public_path__ + "img/young-man.04e37b1e.svg";